import { Component, OnInit } from '@angular/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-lottos-page',
  templateUrl: './lottos-page.component.html',
  styleUrls: ['./lottos-page.component.scss'],
})
export class LottosPageComponent implements OnInit {
  populations = Populations;
  constructor() {}

  ngOnInit() {}
}
